export const replaceSiteUrl = (content) =>
    content && typeof content === 'string'
        ? content.replace(/(http|https):\/\/(localhost:8000|freshegg.gtb.io)/gi, '')
        : '';
